import { Col, Divider, Form, Input, Row } from 'antd';

import AddressUnitsSelector from '../../components/common/AddressUnitSelector';
import {
  CUSTOMER_NAME_MAX_LENGTH,
  EMAIL_MAX_LENGTH,
  PHONE_NUMBER_LENGTH,
  emailRules,
  phoneNumberRules,
} from '../../utils/formRules';

const { TextArea } = Input;

/**
 * Модал доторх хэсгийн гарчиг.
 *
 * Нэмэх хуудас нь ижил бүлгүүдийг Card-аар зааглодог ч модал дотор карт
 * давхарлавал хүрээ давхцаж хүндэрдэг тул энд зураасаар тусгаарлав.
 */
const SectionTitle = ({ children, first = false }) => (
  <Divider orientation="left" orientationMargin={0} style={{ marginTop: first ? 0 : 8 }}>
    {children}
  </Divider>
);

/**
 * Харилцагчийн мэдээлэл засах форм. Модал дотор ажилладаг тул хадгалах/болих
 * товчнууд нь эцэг компонент дээр (ClientsActive) байрлана.
 *
 * Шалгуурууд нь "Харилцагч нэмэх" хуудастай ЯГ ижил байх ёстой — эс тэгвээс
 * нэг хаалгаар оруулахгүй өгөгдөл нөгөө хаалгаар ордог.
 */
const EditClient = ({ form, addressUnits, setAddressUnits }) => (
  <Form layout="vertical" form={form}>
    <SectionTitle first>Ерөнхий мэдээлэл</SectionTitle>

    <Row gutter={16}>
      <Col xs={24} sm={12} xl={8}>
        <Form.Item
          name="name"
          label="Харилцагчийн нэр"
          rules={[{ required: true, message: 'Харилцагчийн нэр дутуу байна!' }]}
          style={{ marginBottom: 0 }}
        >
          <Input placeholder="Энд бич" maxLength={CUSTOMER_NAME_MAX_LENGTH} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} xl={8}>
        <Form.Item
          name="phoneNumber"
          label="Харилцагчийн утас"
          rules={phoneNumberRules()}
          style={{ marginBottom: 0 }}
        >
          {/* `inputMode` нь гар утсан дээр тоон гар нээнэ */}
          <Input placeholder="Энд бич" maxLength={PHONE_NUMBER_LENGTH} inputMode="numeric" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} xl={8}>
        <Form.Item
          name="email"
          label="Харилцагчийн имэйл"
          rules={emailRules('Харилцагчийн имэйл дутуу байна!')}
          style={{ marginBottom: 0 }}
        >
          <Input placeholder="Энд бич" maxLength={EMAIL_MAX_LENGTH} />
        </Form.Item>
      </Col>
    </Row>

    <SectionTitle>Харилцагчийн хаяг</SectionTitle>

    <AddressUnitsSelector form={form} selectedUnits={addressUnits} onChange={setAddressUnits} />

    <Form.Item
      name="addressDetail"
      label="Харилцагчийн дэлгэрэнгүй хаяг"
      style={{ marginBottom: 0 }}
    >
      <TextArea placeholder="Энд бич" rows={3} />
    </Form.Item>

    <SectionTitle>Нэмэлт мэдээлэл</SectionTitle>

    <Form.Item name="description" style={{ marginBottom: 0 }}>
      <TextArea placeholder="Энд бич" rows={3} />
    </Form.Item>
  </Form>
);

export default EditClient;
